import { FC } from 'react';
import theme from '../../../theme';
import Icon from '../Icon';

interface Props {
  width?: string;
  /** A theme colour name (e.g. 'primary') or any CSS colour. */
  color?: string;
}

const CloseIcon: FC<Props> = ({ width = '18', color }) => (
  <Icon
    name="close"
    size={Number(width) || width}
    color={(theme.colors.general as Record<string, string>)[color] || color || theme.colors.general.textSecondary}
  />
);

export default CloseIcon;
